import { createReducer, on, Action } from '@ngrx/store';

import * as StateGuidesActions from './guides.actions';

export const _STATE_GUIDES_FEATURE_KEY = 'stateGuides';

export interface State {
	guides: any; //TODO: write interface
	subjectDegrees: any; //TODO: write interface
	studentCity: any; //TODO: write interface
	studentCareer: any; //TODO: write interface
	loaded: boolean; // has the StateGuides list been loaded
	error?: string | null; // last known error (if any)
	singleGuide: any; //TODO: write interface
}

export interface StateGuidesPartialState {
	readonly [_STATE_GUIDES_FEATURE_KEY]: State;
}

export const initialState: State = {
	// set initial required properties
	guides: null,
	subjectDegrees: null,
	studentCity: null,
	studentCareer: null,
	loaded: false,
	singleGuide: null,
};

const stateGuidesReducer = createReducer(
	initialState,
	on(StateGuidesActions.fetchGuides, (state) => ({
		...state,
		loaded: false,
		error: null,
	})),
	on(StateGuidesActions.updateGuides, (state, stateGuides) => ({
		...state,
		loaded: true,
		guides: stateGuides,
		error: null,
	})),
	on(StateGuidesActions.fetchDegreeGuides, (state) => ({
		...state,
		loaded: false,
		error: null,
	})),
	on(StateGuidesActions.updateDegreeGuides, (state, stateSubjectGuides) => ({
		...state,
		loaded: true,
		subjectDegrees: stateSubjectGuides,
		error: null,
	})),
	on(StateGuidesActions.fetchCityGuides, (state) => ({
		...state,
		loaded: false,
		error: null,
	})),
	on(StateGuidesActions.updateCityGuides, (state, stateCityGuides) => ({
		...state,
		loaded: true,
		studentCity: stateCityGuides,
		error: null,
	})),
	on(StateGuidesActions.fetchCareerGuides, (state) => ({
		...state,
		loaded: false,
		error: null,
	})),
	on(StateGuidesActions.updateCareerGuides, (state, stateCareerGuides) => ({
		...state,
		loaded: true,
		studentCareer: stateCareerGuides,
		error: null,
	})),
	on(StateGuidesActions.loadStateGuidesFailure, (state, { error }) => ({
		...state,
		error,
	})),
	on(StateGuidesActions.fetchSingleGuide, (state) => ({
		...state,
		error: null,
	})),
	on(StateGuidesActions.updateSingleGuide, (state, { singleGuide }) => ({
		...state,
		singleGuide: singleGuide,
		error: null,
	})),
);

export function reducer(state: State | undefined, action: Action) {
	return stateGuidesReducer(state, action);
}
